<template>
  <div class="we-side-bar">
    <we-navbar
      :nav-list="navList"
      @on-add="openFileModal(true)"
      @on-refresh="
        () => {
          this.refreshInit();
        }
      "
      @text-change="setSearchText"
    />
    <we-file-tree
      ref="weFileTree"
      :tree="fileTree"
      :before-change="beforeChange"
      :node-props="nodeProps"
      :loading="compLoading"
      :highlight-path="highlightPath"
      :is-root-default-open="isRootDefaultOpen"
      class="we-side-bar-content"
      @on-refresh="refreshInit"
      @work-bench-click="benchClick"
      @work-bench-edit="benchEdit"
      @work-bench-dblclick="openToTABAction()"
      @work-bench-contextMenu="benchContextMenu"
    />
    <we-menu ref="treeContextMenu" id="hdfs">
      <we-menu-item v-if="currentNode.isLeaf" @select="openToTABAction()">
        <span>{{ $t("message.hdfs.contextMenu.openToTab") }}</span
        ><span>Ctrl+Enter</span>
      </we-menu-item>
      <we-menu-item class="ctx-divider" v-if="currentNode.isLeaf" />
      <we-menu-item
        v-if="!currentNode.isLeaf"
        @select="openFileModal(false)"
      >
        <span>{{ $t("message.hdfs.contextMenu.addCatalog") }}</span>
      </we-menu-item>
      <we-menu-item v-if="!currentNode.isLeaf" @select="handleEditBefore">
        <span>{{ $t("message.constants.rename") }}</span>
      </we-menu-item>
      <!-- <we-menu-item
        v-if="
          currentNode.isLeaf &&
          currentNode.data &&
          currentNode.data.status === 1
        "
        @select="handleOffline"
      >
        <span>下线</span>
      </we-menu-item> -->
      <we-menu-item class="ctx-divider" v-if="!currentNode.isLeaf"/>
      <we-menu-item
        @select="
          () => {
            this.refreshInit();
          }
        "
      >
        <span>{{ $t("message.constants.refresh") }}</span>
      </we-menu-item>
      <we-menu-item
        v-if="
          !currentNode.isLeaf &&
          currentNode._childNodes &&
          currentNode._childNodes.length === 0
        "
        @select="openDeleteModal"
      >
        <span>{{ $t("message.constants.delete") }}</span>
      </we-menu-item>
    </we-menu>
    <new-dialog
      ref="newFile"
      :loading="loading"
      :targetFolder="newDialog.targetFolder"
      :id="newDialog.parentId"
      :tree="tree"
      @newNode="newNode"
    />
    <delete-dialog ref="delete" :loading="loading" @delete="handleDelete" />
  </div>
</template>
<script>
import {
  indexOf,
  isEmpty,
  cloneDeep,
} from "lodash";
// import util from "@dss/js/util";
import storage from "@dss/js/helper/storage";
import weFileTree from "@dss/js/component/fileTree";
import weNavbar from "@dss/js/component/navbar/navbar.vue";
import newDialog from "@dss/js/component/newDialog/index-api.vue";
import deleteDialog from "@dss/js/component/deleteDialog";
import { WORKSPACEIDKEY, WORKSPACENAMEKEY } from "@/api/index";
import { requestWithSign, ROOT_SERVER } from "@/api";
export default {
  name: "WorkSidebar",
  components: {
    weFileTree,
    weNavbar,
    newDialog,
    deleteDialog,
  },
  data() {
    return {
      rootPath: "",
      currentNode: {},
      nodeProps: {
        children: "children",
        label: "name",
        icon: "icon",
        isLeaf: "isLeaf",
      },
      fileTree: [], //树的数据
      treeList:[],
      tree:[],
      totalTree:[],
      // 用于延迟渲染模块，减少请求
      timeoutFlag: true,
      navList: ["search", "newFile", "refresh"],
      sharePath: "",
      shareTree: [],
      loadShareDataFn: () => {},
      fsType: "api",
      dbList: [],
      hiveComponent: null,
      loading: false,
      compLoading: false,
      treeLoading: false,
      highlightPath: "",
      isRootDefaultOpen: true,
      newDialog: {
        targetFolder: "/",
        parentId: null,
      },
    };
  },
  computed: {},
  mounted() {
    this.initData();
    // this.getAcitveTabAndSetHighlight();
  },
  methods: {
    initData() {
      this.compLoading = true;
      this.treeLoading = true;
      this.getTree((tree,list) => {
        this.treeLoading = false;
        this.compLoading = false;
        if (!tree) return;
        let treeList = [
          {
            name: "default",
            isLeaf: false,
            children: list,
          },
        ];
        this.fileTree = treeList;
        this.tree = tree.filter(item=>!item.leaf);
      });
    },
    async getTree(cb) {
      const timeout = setTimeout(() => {
        this.compLoading = true;
      }, 2000);
      let { data, retCode, msg } = await requestWithSign({
        method: "GET",
        url: `${ROOT_SERVER}/data-api-development-rest/catalogues?workspaceId=${storage.get(
          WORKSPACEIDKEY,
          "cookie"
        )}`,
        token: storage.get("access-user-token", "cookie"),
      }).catch((err) => {
        console.log(err);
      });
      clearTimeout(timeout);
      this.compLoading = false;
      this.timeoutFlag = true;
      if (retCode === "00000") {
        const tree = data || [];
        this.treeList = tree;
        let list = this.arrToTree(tree);
        this.totalTree = list;
        cb(tree,list);
      } else {
        this.$Message.error("查询失败");
      }
    },
    arrToTree(arr, id = null) {
      const res = [];
      arr.forEach((item) => {
        item.isLeaf = item.leaf;
        if (item.parentId === id) {
          const children = this.arrToTree(
            arr.filter((v) => v.parentId !== id),
            item.id
          );
          if (children.length) {
            res.push({ ...item, children });
          } else {
            res.push({ ...item });
          }
        }
      });
      return res;
    },
    setSearchText(value) {
      if (value&&this.treeLoading)
        return this.$Message.warning(this.$t("message.constants.warning.data"));
      this.searchText = value;
     let newTree = this.filter(this.totalTree, value);
      let treeList = [
        {
          name: "default",
          isLeaf: false,
          children: newTree,
        },
      ];
      this.fileTree = treeList;
    },
    filter(tree, str) {
      const newTree = [];
      tree.forEach((val) => {
        const children = this.filter(val.children || [], str);
        if (children.length) {
          let obj = JSON.parse(JSON.stringify(val));
          obj.expanded = true;
          newTree.push({ ...obj, children });
        }else{
          if (~val.name.indexOf(str)) {
            newTree.push(val);
          } 
        }
      });
      return newTree;
    },
    benchClick(...args) {
      this.currentNode = args[0].node;
      this.$refs.treeContextMenu.close();
    },
    benchContextMenu({ node, ev }) {
      this.currentNode = node;
      this.$refs.treeContextMenu.open(ev);
    },
    benchdbClick({ node }) {
      if (node.isLeaf) {
        this.openToTABAction(node.data);
      }
    },
    openToTABAction(node) {
      const openNode = node || this.currentNode.data;
      if (this.currentNode.isLeaf) {
        this.dispatch(
          "Workbench:openFile",
          {
            filename: openNode.name,
            type: openNode.type || "apiScript",
            saveAs: true,
            id: openNode.id,
            status: openNode.status,
          },
          () => {}
        );
      }
    },
    // copyPathAction() {
    //   util.executeCopy(this.currentNode.data.path);
    // },
    openFileModal(isRoot) {
      if (this.treeLoading)
        return this.$Message.warning(this.$t("message.constants.warning.data"));
      // let node = this.currentNode.data;
      // // 这里是对初始化时，用户去点击navbar时，没有currentNode的情况
      // // 此时的currentNode.data是个数组
      // if (isEmpty(this.currentNode)) {
      //   this.currentNode = this.$refs.weFileTree.$refs.tree.root;
      //   node = this.currentNode.data[0];
      // }
      // let url = this.getPath(this.currentNode);
      // console.log(url)
      // this.newDialog = {
      //   type: this.$t("message.deleteType.catalog"),
      //   isNew: true,
      //   node: node || {},
      //   isLeaf,
      //   targetFolder: url,
      // };
        if (isRoot) {
        this.newDialog = { targetFolder: "/", parentId: null };
      } else {
        let url = this.getPath(this.currentNode);
        this.newDialog = {
          targetFolder: url,
          parentId: this.currentNode.data.id,
        };
      }
      this.$refs.newFile.open();
    },
    
    getPath(node, list = []) {
      if (node.parent && node.parent.data && node.data.id) {
        list.push(node.data.name);
        return this.getPath(node.parent, list);
      } else {
        let url = list.reverse().join("/");
        return url ? "/" + url : "/";
      }
    },
  
    handleEditBefore() {
      this.currentNode.changeEditState(true);
    },
    beforeChange(args, cb) {
      let { label, node } = args;
      let { parentId, id } = node;
      if (
        this.checkExist({
          name: label,
          id: id,
          parentId: parentId || null,
        })
      ) {
        cb(false);
        return this.$Message.error(
          `${this.$t("message.constants.error.folderExists")}：${label}`
        );
      }
      this.saveDir(label, id, parentId, (status) => {
        cb(status);
      });
    },
    benchEdit(...args) {
      //编辑
      // const { node, oldLabel } = args[0];
      // const { id, parentId } = node.data;
    },
    openDeleteModal() {
      this.$refs.delete.open({
        type: this.$t("message.deleteType.folder"),
        name: this.currentNode.label,
      });
    },
    async handleDelete() {
      if (this.loading)
        return this.$Message.warning(
          this.$t("message.constants.warning.waiting")
        );
      this.loading = true;
      let { data, retCode, msg } = await requestWithSign({
        method: "DELETE",
        url: `${ROOT_SERVER}/data-api-development-rest/catalogue/${this.currentNode.data.id}`,
        token: storage.get("access-user-token", "cookie"),
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });
      this.loading = false;
      if (retCode === "00000") {
        this.$Message.success(this.$t("message.constants.success.delete"));
        let index = this.treeList.findIndex(item=>item.id===this.currentNode.data.id);
        if (index > -1) {
          this.treeList.splice(index, 1);
          this.currentNode.remove();
        }
        this.initData();
      }

    },

    filterNode(node) {
      return !node.isLeaf;
    },
    refreshInit() {
      this.initData();
    },
    "apiSidebar:refresh"(cb) {
      this.compLoading = true;
      this.treeLoading = true;
      this.getTree((tree,list) => {
        this.treeLoading = false;
        this.compLoading = false;
        if (!tree) {
          cb && cb(false);
          return;
        }
        let treeList = [
          {
            name: "default",
            isLeaf: false,
            children: list,
          },
        ];
        this.fileTree = treeList;
        cb && cb(tree);
      });
    },
    revealInSideBar(work) {
      let { id, name } = work;
      if (!work || !work.filepath) {
        return;
      }
      // 获得父级文件路径数组
      let fileDirs = work.filepath.replace(this.rootPath, "").split("/");
      fileDirs.pop();
      fileDirs = fileDirs
        .filter((item) => item)
        .map((item, index) => {
          return item
            ? this.rootPath + fileDirs.slice(0, index + 1).join("/")
            : false;
        });
      // 遍历文件树查找需要加载数据的路径
      let needLoadDirs = [];
      fileDirs.forEach((item, index) => {
        const travers = (treeNode) => {
          treeNode.forEach((node) => {
            if (node.path === item && !node.children) {
              needLoadDirs = fileDirs.slice(index, fileDirs.length);
              return;
            }
            if (node.children) {
              travers(node.children);
            }
          });
        };
        travers(this.fileTree);
      });

      // 依次向下展开work.filepath相应节点, 需要展开的路径：needLoadDirs
      const expandFileDir = (dirs) => {
        let index = 0;
        const expand = (index) => {
          if (index < dirs.length) {
            const dirPath = dirs[index++];
            const travers = (treeNode) => {
              treeNode.forEach((node) => {
                if (node.path === dirPath) {
                  node.expanded = true;
                  return;
                }
                if (node.children) {
                  travers(node.children);
                }
              });
            };
            travers(this.fileTree);
            this.$nextTick(() => {
              expand(index);
            });
          }
        };
        expand(index);
      };

      // 没有children数据，请求加载目录数据之后展开目录，已加载数据则直接展开
      if (needLoadDirs.length > 0) {
        const loadDirPromises = needLoadDirs.map((path) => {
          return api
            .fetch(
              `/filesystem/getDirFileTrees`,
              {
                path: path,
                workspaceId: id,
                workspaceName: name,
              },
              "get"
            )
            .then((res) => res.dirFileTrees);
        });

        Promise.all(loadDirPromises).then((res) => {
          res.reverse();
          const reducer = (accumulator, currentValue) => {
            currentValue.children.forEach((item) => {
              if (item.path === accumulator.path) {
                item.children = accumulator.children;
              }
              item.expanded = false;
            });
            currentValue.expanded = false;
            return currentValue;
          };
          let data = res.reduce(reducer);
          // 更新树数据源
          const travers = (treeNode) => {
            treeNode.forEach((node) => {
              if (node.path === data.path) {
                node.children = data.children;
                return;
              }
              if (node.children) {
                travers(node.children);
              }
            });
          };
          travers(this.fileTree);
          expandFileDir(needLoadDirs);
        });
      } else {
        // 展开work.filepath相应节点,路径上节点统一expanded初始化false
        const travers = (treeNode) => {
          treeNode.forEach((node) => {
            if (fileDirs.indexOf(node.path) > -1) {
              node.expanded = false;
            }
            if (node.children) {
              travers(node.children);
            }
          });
        };
        travers(this.fileTree);
        this.$nextTick(() => {
          expandFileDir(fileDirs);
        });
      }
    },
    // "apiSidebar:setHighLight": debounce(function (work) {
    //   if (!work) return (this.highlightPath = "");
    //   const path = work.filepath;
    //   const userName = this.getUserName();
    //   const highLightList = path.split("/");
    //   const index = highLightList.indexOf(userName);
    //   highLightList.splice(0, index);
    //   this.highlightPath = highLightList.join("/");
    // }, 500),

    newNode(data) {
      if (this.loading)
        return this.$Message.warning(
          this.$t("message.constants.warning.waiting")
        );
      if (
        this.checkExist({
          name: data.name,
          id: "",
          parentId:data.parentId || null,
        })
      ) {
        this.$Message.warning("目录名称重复,创建失败");
        return;
      }
      this.saveDir(data.name, "", data.parentId,(status)=>{
        if(status){
          this.refreshInit();
        }
      });
    },
    "apiSidebar:getTreeList"(cb){
      cb(this.treeList);
    },
    "apiSidebar:updateLeafName"({id, name}) {
      let index = this.treeList.findIndex((item) => item.id === id);
      this.treeList[index].name = name;
      let fileTree = [
          {
            name: "default",
            isLeaf: false,
            children: this.arrToTree(this.treeList),
          },
        ];
      this.fileTree = fileTree;
    },
    async saveDir(name, id, parentId, cb) {
      //保存目录
      let { data, retCode, msg } = await requestWithSign({
        method: "POST",
        url: `${ROOT_SERVER}/data-api-development-rest/catalogue`,
        data: {
          name,
          id: id || "",
          parentId,
          workspaceId: storage.get(WORKSPACEIDKEY, "cookie"),
        },
        token: storage.get("access-user-token", "cookie"),
      }).catch((err) => {
        cb && cb(false);
        this.$Message.error("保存目录失败");
        console.log(err);
      });
      if (retCode == "00000") {
        cb && cb(true);
      } else {
        cb && cb(false);
        this.$Message.error("保存目录失败");
      }
    },
    checkExist({ name, id, parentId = null }) {
      let tree = this.treeList;
      let isExist = tree
        .filter((item) => item.parentId === parentId)
        .find((item) => {
          return item.id !== id && item.name === name;
        });
      return isExist;
    },
    updateNode(...rest) {
      console.log("update", rest);
    },
    // handleOffline() {
    //   //下线
    //   console.log("下线");
    // },
  },
};
</script>
<style src="@dss/assets/styles/sidebar.scss" lang="scss"></style>
